module.exports = __webpack_public_path__ + "media/components/assets/icons/register_event-408c59956bf156fb979c4ed97414dfee.svg";